import moment from 'moment'
import { instance as store } from 'app/store'
import { getJoinedChannel } from 'app/utils/data/socket'

const initialState = {
  uploading: false,
  error: null,
  completed: false,
  lastUpdated: null
}

export default {
  namespaced: true,

  state: {
    ...initialState
  },

  getters: {
    completed: (state) => state.completed,
    uploading: (state) => state.uploading,
    error: (state) => state.error,
    lastUpdated: (state) => state.lastUpdated
  },

  mutations: {
    setUploading(state, { status }) {
      state.uploading = status
    },

    setCompleted(state, { completed }) {
      state.completed = completed
    },

    setError(state, { error }) {
      state.error = error
    },

    transition(state, transitions) {
      Object.keys(transitions).forEach((key) => {
        state[key] = transitions[key]
      })
    },

    resetState(state) {
      Object.assign(state, { ...initialState })
    }
  },

  actions: {
    async uploadPackage({ commit }, kitToken) {
      return new Promise(function (resolve, reject) {
        commit('transition', { uploading: true, completed: false, error: false })
        const callbackRefs = []

        const errorCallback = (error, channel) => {
          commit('transition', { error: true, uploading: false })
          if (channel) {
            channel.off(callbackRefs)
          }
          const e = 'string' === typeof error ? new Error(error) : error
          reject(e)
        }

        getJoinedChannel('/jobs', `kit-jobs:${store.getters['accounts/currentAccount']?.id}`)
          .then((channel) => {
            const refComplete = channel.on('complete_kit_npm_package', (data) => {
              // If the current kit is the one that's done building, then update its waiting status.
              // However, it's possible that multiple kits could be in progress. Since
              // the channel is tied to a particular account, any kit owned by that
              // account might be the subject of a 'complete' message.
              if (kitToken == data.kitToken) {
                commit('transition', { completed: true, uploading: false, lastUpdated: moment.now() })
                channel.off(callbackRefs)
                resolve()
              }
            })

            const refTimeout = channel.on('timeout_kit_npm_package', (data) => {
              if (kitToken == data.kitToken) {
                errorCallback('timeout_kit_npm_package', channel)
              }
            })

            const refFailed = channel.on('failed_kit_npm_package', (data) => {
              if (kitToken == data.kitToken) {
                errorCallback('failed_kit_npm_package', channel)
              }
            })

            const refError = channel.onError(() => {
              errorCallback('channel error', channel)
            })

            // Add all of these callback refs so they can all be cleaned up
            // when we're done with this use of the channel. If this function
            // is called again, it will add new callbacks for the channel events.
            // Otherwise, each time this function is invoked, the callbacks get
            // added *in addition* to the callbacks added in earlier invocations.
            // We don't want multiple callbacks being invoked per event on subsequent
            // invocations of this function.
            callbackRefs.splice(0, -1, refComplete, refTimeout, refError, refFailed)

            channel.push('build_kit_npm_package', { kitToken }).receive('error', () => errorCallback('build_kit_npm_package', channel))
          })
          .catch(errorCallback)
      })
    }
  }
}
